import {APIRequest} from "../modules/APIRequest.js";

(async ()=>{
	var pending_submit = false;

	$("#register-form").submit(async function(e){
		e.preventDefault();
		
		if(pending_submit) return;
		pending_submit = true;
		$("#submit_btn").html('<i class="fas fa-sync fa-spin"></i> Please wait...').prop('disabled', true);
		
		var real_name = $("#register-name-input").val().trim();
		var email = $("#register-email-input").val().trim();
		var password = $("#register-password-input").val();
		var confirm_password = $("#register-password-input-conf").val();
		
		if(!validateEmail(email)){
			$("#submit_btn").html('<i class="fas fa-user-plus"></i> Register').prop('disabled', false);
			pending_submit = false;
			showFormError('Please enter a valid email address.');
			return;
		}
		
		if(real_name.length < 3){
			$("#submit_btn").html('<i class="fas fa-user-plus"></i> Register').prop('disabled', false);
			pending_submit = false;
			showFormError('Please enter a full name.');
			return;
		}
		
		if(password.length < 4){
			$("#submit_btn").html('<i class="fas fa-user-plus"></i> Register').prop('disabled', false);
			pending_submit = false;
			showFormError('Password is too short. Must be at least 4 characters.');
			return;
		}
		
		if(password !== confirm_password){
			$("#submit_btn").html('<i class="fas fa-user-plus"></i> Register').prop('disabled', false);
			pending_submit = false;
			showFormError('Passwords don\'t match.');
			return;
		}
		
		if(!$("#tou-cb").is(":checked")){
			$("#submit_btn").html('<i class="fas fa-user-plus"></i> Register').prop('disabled', false);
			pending_submit = false;
			showFormError('Must agree to the Privacy Policy.');
			return;
		}
		
		var request = new APIRequest();
		request.set('register', 'real_name', real_name);
		request.set('register', 'email', email);
		request.set('register', 'password', password);
		var result = (await request.send()).register;
		
		if(result.errors.length){
			showFormError(result.errors.join(" "));
		}else{
			$("#form-inputs").hide();
			showFormSuccess(`Your account has been created. Please check your email to continue.`);
			this.reset();
		}
		$("#submit_btn").html('<i class="fas fa-user-plus"></i> Register').prop('disabled', false);
		pending_submit = false;
		
	});


	function showFormError(message){
		$("#form-error").html('<i class="fas fa-skull-crossbones"></i> '+message);
		$("#form-error").show();
		$("#form-success").hide();
		window.scrollTo(0, 0);
	}

	function showFormSuccess(message){
		$("#form-success").html('<i class="far fa-thumbs-up"></i> '+message);
		$("#form-success").show();
		$("#form-error").hide();
		window.scrollTo(0, 0);
	}

	function validateEmail(email) {
		return !!/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/.test(email);
	}

})();
